import * as Yup from 'yup';
import { Icon } from '@iconify/react';
import { alpha, Button, Dialog, IconButton, OutlinedInput, Stack, Typography } from '@mui/material';
import React from 'react';
import { dispatch } from '../../redux/store';
import { saveNewsletters } from '../../redux/slices/newsletters';
import { useSnackbar } from 'notistack';

const validationEmail = Yup.object().shape({
  email: Yup.string().email('Entrez une adresse e-mail valide').required("L'adresse e-mail est requise"),
});

export default function NewsLetterModal({ open, onClose }) {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = () => {
    validationEmail
      .validate({ email })
      .then(() => {
        dispatch(
          saveNewsletters(
            { email, name },
            () => {
              enqueueSnackbar('Vous êtes désormais souscrit à notre newsletter', { variant: 'success' });
            },
            (saveError) => {
              if (saveError?.status === 409) {
                enqueueSnackbar('Vous êtes déjà inscrit à notre newsletter', { variant: 'warning' });
              } else {
                enqueueSnackbar("Une erreur s'est produite", { variant: 'error' });
              }
            }
          )
        );
        onClose();
      })
      .catch((err) => setError(err.errors?.at(0)));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundImage: 'url(/assets/background/Sidebar_1.jpg)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        },
      }}
    >
      <Stack width={1} bgcolor={alpha('#11d6a5', 0.5)}>
        <Stack width={1} alignItems="end" mb={5}>
          <IconButton onClick={onClose}>
            <Icon icon="eva:close-fill" height={30} width={30} color="black" />
          </IconButton>
        </Stack>
        <Typography variant="h3" textAlign="center" mb={3} fontFamily="serif">
          Newsletter abonnez-vous
        </Typography>
        <Stack width={1} alignItems="center" mb={10} spacing={1}>
          <OutlinedInput
            placeholder="Nom & Prénoms"
            onChange={(e) => setName(e.currentTarget.value)}
            sx={{ width: 450, bgcolor: 'white' }}
          />
          <OutlinedInput
            startAdornment={
              <Icon icon="lucide:mail" height={25} width={25} color="#ADB1B1" style={{ marginRight: 10 }} />
            }
            onChange={(e) => setEmail(e.currentTarget.value)}
            placeholder="Entrez votre email"
            sx={{ bgcolor: 'white', width: 450 }}
          />
          <Typography color="error" textAlign="start">
            {error}{' '}
          </Typography>

          <Button sx={{ width: 450 }} color="primary" variant="contained" onClick={handleSubmit}>
            S'ABONNER
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
